    import { Component, Inject, Input} from 'ng-metadata/core';
    import {DateUtils} from '../../../nddUtils/dateUtils.service';
    import {SavedQueriesService, SavedQueryItem} from '../../../favorites/savedQueries/savedQueries.service';
    import {AddQueryToSavedSearchesService} from '../../savedQueries/addQueryToSavedSearches/addQueryToSavedSearches.service';
    import {UserSessionManagerService} from  '../../../security/userSessionManager.service';
    import {SearchHistoryService} from '../../../favorites/searchHistory/searchHistory.service';
    import {ConfigurationUtil} from "../../../nddUtils/configurationUtil.service";
    import {beacon, PrimolyticsService} from '../../../analytics/primolytics.service';
    import {getVid} from '../../../appConfig/appConfigForward';

    const replace  = require('lodash/replace');
    const _get = require('lodash/get');



    @Component({
        'selector': 'prm-saved-queries-list',
        templateUrl: 'components/search/searchResult/savedQueriesList/saved-queries-list.html'
     })


    export class PrmSavedQueriesList {
        @Input() itemlist: Array<SavedQueryItem>;
        private preFilterMap;
        private prefixCodesForTypes;
        @Input() isSearchHistory:boolean;//true is the serviced is used in search history tab
        constructor(private dateUtils:DateUtils,
                    private savedQueriesService:SavedQueriesService,
                    private searchHistoryService:SearchHistoryService,
                    @Inject('savedSearches') private savedSearches,
                    @Inject('$mdToast') private $mdToast: ng.material.IToastService,
                    @Inject('$translate') private $translate: ng.translate.ITranslateService,
                    @Inject('$filter') private filterService: angular.IFilterService, 
                    private addQueryToSavedSearchesService: AddQueryToSavedSearchesService,
                    private userSessionManagerService:UserSessionManagerService,
                    private configurationUtil: ConfigurationUtil,
                    private primolyticsService:PrimolyticsService,
                    @Inject('restBaseURLs') private restBaseURLs){
            this.preFilterMap = {'pfilter':'material_type',
                                   'lang':'language',
                                   'creationdate':'publication_date',
                                   'dr_s':'DateRangeStart',
                                   'dr_e':'DateRangeEnd'};

            this.prefixCodesForTypes ={'material_type':'search-advanced.mediaType.option.',
                                        'language':'search-advanced.language.option.',
                                        'publication_date':'',
                                        'DateRangeStart':'search-advanced.DateRange.label.',
                                        'DateRangeEnd':'search-advanced.DateRange.label.'};
        }

        convertDate(date) {
            if(this.isSearchHistory){
            	  try {
                	  let adate = /(\d{2})\/(\d{1,2})\/(\d{4}) (\d{2}):(\d{2}):(\d{2})/.exec(date);
                	  let odate = new Date (adate[3],adate[2]-1,adate[1],adate[4],adate[5],adate[6]);
	            	  let parsedDate = this.filterService('date')(odate, this.dateUtils.primoLongDateFormat);
	                  return parsedDate; //  this.dateUtils.convertDateTypeToFormatString(odate, this.dateUtils.primoLongDateFormat); //search history items date, is displays the date and time, and saved searches only the date
                  } catch (err) {
                	  console.log('Cannot format date ['+date+'] with formate:' + this.dateUtils.primoLongDateFormat);
                  	  console.error(err);
                  	  
                  	  return date;
                  }
                  
            }
            return this.dateUtils.convertIlsDateStringToPrimoDateString(date);
        }


        decodeString(str:string){
            return decodeURI(str);
        }


        private getPfilterMap(pfilterType){
            return this.preFilterMap[pfilterType];
        }

        private getPrefixCodeAccordingToType(pfilterType) {
            return this.prefixCodesForTypes[pfilterType];
        }




        private removeSearch(searchId){
            this.savedQueriesService.removeSearch(searchId)
                .then((res) =>{
                    console.log('entire res:' + JSON.stringify(res));
                    this.savedQueriesService.getItemsFromApi();
                }, (reason) => {
                    console.log('get searches failed: ',reason);
                });

        }

        private updateAlert(item, email:string = ''){
            let searchId = item.ID;
            let isAlert = (item.alert?0:1);
            this.savedQueriesService.updateAlerts(item, email)
                .then((res) =>{
                    console.log('entire res:' + JSON.stringify(res));
                    item.alert = !item.alert;
                    item.email = res;


                    if(isAlert) {
                        let templateString = '<prm-add-alert-toast [id]="ctrl.searchId" [add-mode]="ctrl.addMode"></prm-add-alert-toast>';

                        this.$mdToast.show({
                            controllerAs: 'ctrl',
                            controller: function(){
                                this.searchId= searchId;
                                this.addMode= false;
                            },
                            hideDelay   : 8000,
                            position    : 'top right',
                            template : templateString
                        }).then(()=>{this.addQueryToSavedSearchesService.onToastClose()});
                   }

                }, (reason) => {
                    console.log('get searches failed: ',reason);
                });

        }

        @beacon({'p':'rssSubscription', 'op': 'click'})
        private createRSS(item){
            let searchId = item.ID;
            let query:string = item.query.split(',')[2];
            if( query.split('%20').length > 9 ){
                query = query.split('%20').slice(0,9).join('%20');
            }        
                let url=this.restBaseURLs.rss +'?rssId='+searchId+"&queryTerm=" + item.query.split(',')[2]+ '&vid=' + getVid() +'&amp;ver=2_1_4';
                var f=document.getElementById("RRSFORM");
                f.action=url;
                var input = document.createElement("input");
                input.setAttribute("type","hidden");
                input.setAttribute("name","sr");
                input.setAttribute("value",item.sr);
                f.appendChild(input);
                input = document.createElement("input");
                input.setAttribute("type","hidden");
                input.setAttribute("name","encCtxt");
                input.setAttribute("value",item.encCtxt);
                f.appendChild(input);
                f.submit();
                console.log(item);
        }
        //private popupWin: Window;
        private successRssAction(response) {
        	console.log(response);
            //let serviceUrl = response.data.serviceUrl;
            //let data = response.data;
            //this.popupWin = window.open('data:text/xml,'+response.data, '_blank');
            //let popupWin = window.open('', '_blank');

            //popupWin.document.open('text/xml',"replace");
           // popupWin.document.innerHtml=response.data;
           // popupWin.document.close();
            console.log("Rss successfully sent");

        }

        private failedRssAction(response) {
            console.log("Rss call failed");
            console.log("Event:" + event);
            console.log(response);
        }

           private getSavedQueriesHeader() {
               if (!this.itemlist){
                   return undefined;
               }
               let placeHolders:any = {idx_0: (this.isSearchHistory ? this.searchHistoryService.totalItems.length : this.savedQueriesService.totalItems.length) };
               return this.$translate.instant('nui.favorites.search.items', placeHolders);
         }

    public getCheckedItems(){
        if(!this.itemlist){
            return [];
        }
        return this.itemlist.filter((item)=>{return item.checked});
    }

    public isAllChecked(){
        if (!this.itemlist){
            return false;
        }
        return this.itemlist.length === this.getCheckedItems().length;
    }

    private selectAllToggle(){
        if (this.isAllChecked()){
            for(let item of this.itemlist){
                item.checked= false;
            }
        }
        else{
            for(let item of this.itemlist){
                item.checked= true;
            }
        }
    }

    private userName() {
        return this.userSessionManagerService.getUserName();
    }

    private isLoggedIn(){
        return this.userName().length > 0;
    }

    /*
     removes the Search History Item which id is searchHistoryItemId from the local forage
    */
    private removeSearchHistoryItem(searchHistoryItemId){
        this.searchHistoryService.removeSearchHistoryItem(searchHistoryItemId)
            .then((resultItemsList) => {
                this.searchHistoryService.setTotalItems(resultItemsList);// reloads the items list to display the updated one
                this.searchHistoryService.refreshItems();//assign to items, the number of items to display.
            });
    }

    /*
    saves the Search History Item which ID is searchHistoryItemId, To Saved Searches.
    then pops a toast which asks the user if he wants to add a mail alert to this query
    */
    public saveSearchHistoryItemToSavedSearches(searchHistoryItemId){
        this.searchHistoryService.saveSearchHistoryItemToSavedSearches(searchHistoryItemId);
    }

    /*
    removes the Search History Item which ID is searchHistoryItemId, from Saved Searches.
    */
    public removeSearchHistoryItemFromSavedSearches(searchHistoryItemId){
        this.searchHistoryService.removeSearchHistoryItemFromSavedSearches(searchHistoryItemId);
    }

    /*
    returns the next none displayed bulk of search history items,
    to display them in an infinite scroll
    */
    public nextResults(){
        if(this.isSearchHistory)
        {
            this.searchHistoryService.nextResults();
        }
        else
        {
            this.savedQueriesService.nextResults();
        }
    }

    /*
    returns the next none displayed bulk of search history items,
    to display them in an infinite scroll
    */
    public hasNextResults(){
        if(this.isSearchHistory)
        {
            return this.searchHistoryService.hasNextResults();
        }
        return this.savedQueriesService.hasNextResults();
    }

    /*
    returns true if Search History Item, which id is searchHistoryItemID,
    is saved in Saved Searches, based on its facet, pfilter, scope, query.
    */
    public isSearchHistoryItemInSavedSearches(SearchHistoryItem){
        return this.searchHistoryService.isSearchHistoryItemInSavedSearches(SearchHistoryItem);
    }


    public isDisplayAlert(item: SavedQueryItem){
        let displayAlertToast = true;

        if(this.configurationUtil.isSuprima()){
            let scopeId =  item.scope;
            let scopesObj = this.configurationUtil.getScopesObj(scopeId);
            let locations = _get(scopesObj,'[0].locations');
            if(locations){
                let locationsArr = locations.split(',');
                if(locationsArr.includes('EbscoLocal') || locationsArr.includes('WorldCatLocal')){
                    displayAlertToast = false;
                }
            }
        }
        return displayAlertToast;
    }

}


// WEBPACK FOOTER //
// ./src/main/webapp/components/search/searchResult/savedQueriesList/savedQueriesList.directive.ts